import styled from "styled-components"

// Card Container
const CardContainerComponent = styled.div`
    background-color: #dfe4ea;
    border-radius: 10px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    height: 15rem;
    width: 25rem;
`
export const CardContainer = (props)=>{
    return(
        <CardContainerComponent className={props.className}>
            {props.children}
        </CardContainerComponent>
    )
}
// Header Card Container
const HeaderContainerComponent = styled.div`
    background-color: ${props => props.backgroundColor};
    border-radius: 10px 10px 0 0;
    display: grid;
    align-items: center;
    justify-content: space-around;
    grid-auto-flow: column;
    column-gap: 4em;
    width: 25rem;
    height: 3.5rem;
`
export const HeaderContainer = (props)=>{
    return(
        <HeaderContainerComponent backgroundColor={props.backgroundColor}>
            {props.children}
        </HeaderContainerComponent>
    )
}
export const HeaderCardGroup = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    column-gap: 0.5em;
`
// Body Front Card Container
const BodyFrontContainerComponent = styled.div`
    /* background-color: rebeccapurple; */
    display: grid;
    align-items: start;
    justify-content: start;
    grid-auto-flow: column;
    column-gap: 4em;
    width: 22rem;
    height: 11.5rem;
    margin: 0 auto;
    margin-top: 1em;
`
export const BodyFrontContainer = (props)=>{
    return(
        <BodyFrontContainerComponent backgroundColor={props.backgroundColor}>
            {props.children}
        </BodyFrontContainerComponent>
    )
}
export const CardGroup = styled.div`
    display: grid;
    grid-auto-flow: row;
    justify-content: start;
    align-items: start;
    row-gap: 0.2em;
`